import { QueryResponseCache } from 'relay-runtime';

// Módulo próprio para quem só precisa limpar o cache no logout (reducers/sagas) não importar
// relay/index.tsx, que importa o store — o import ficava circular.
const oneMinute = 60 * 1000;
export const cache = new QueryResponseCache({ size: 250, ttl: 10 * oneMinute });
